module.exports = __webpack_public_path__ + "static/media/companyLogos.925b63f5.svg";